/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SrsConnectivityModel } from '../../models/srs-connectivity-model';

export interface GetSrsConnectivity$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
}

export function getSrsConnectivity(http: HttpClient, rootUrl: string, params: GetSrsConnectivity$Params, context?: HttpContext): Observable<StrictHttpResponse<SrsConnectivityModel>> {
  const rb = new RequestBuilder(rootUrl, getSrsConnectivity.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SrsConnectivityModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getSrsConnectivity.PATH = '/api/srsconnectivity/{systemSerialNumber}/{systemMaterialNumber}';
getSrsConnectivity.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getSrsConnectivity.ROOTURL = '/portal';
